import Main from './Main.vue'
import Usuarios from './components/Usuarios.vue'
import VisualizarUsuario from './components/VisualizarUsuario'
import Usuario from './components/Usuario'

export default [{
  path: 'usuarios',
  component: Main,
  children: [
    {path: '/', component: Usuarios, name: 'usuarios'},
    {path: 'registro', component: Usuario, name: 'usuario.novo'},
    {path: ':id', component: VisualizarUsuario, name: 'usuarios.visualizar'},
    {path: ':id/edit', component: Usuario, name: 'usuario.editar'}
  ]
}
]



// WEBPACK FOOTER //
// ./src/app/website/usuarios/routes.js